import {GSX_ARTICLE_TYPES, ORDER_TYPE_CODE,} from '../../GSXComponents'

let RepairMenu = {
    icon: 'fas fa-toolbox',
    label: 'GSX',
    content: [],
}

RepairMenu.content.push({
    icon: 'fas fa-toolbox',
    label: "Repairs",
    to: `/dashboard/gsx/repairs/`,
})
RepairMenu.content.push({
    icon: 'fas fa-toolbox',
    label: "Apple Care",
    to: `/dashboard/gsx/apple_care/`,
})
RepairMenu.content.push({
    icon: 'fas fa-toolbox',
    label: "Consignments",
    to: `/dashboard/gsx/consignments/`,
})
RepairMenu.content.push({
    icon: 'fas fa-toolbox',
    label: "Orders",
    to: `/dashboard/gsx/orders/`,
})
RepairMenu.content.push({
    icon: 'fas fa-toolbox',
    label: "Content",
    to: `/dashboard/gsx/contents/`,
})

RepairMenu.content.push({
    icon: 'fas fa-dolly',
    label: 'Logs',
    to: '/admin/gsx_log',
    roles: ['SuperUser', 'Privileged'],
})

let ArticleMnu = {
    icon: 'fas fa-toolbox',
    label: 'GSX Articles',
    content: [],
}
GSX_ARTICLE_TYPES.forEach((x) => {
    ArticleMnu.content.push({
        icon: 'fas fa-toolbox',
        label: x.label,
        to: `/dashboard/gsx_content/${x.code}`,
    })
})

let PeopleMenu = {
    icon: 'fas fa-users',
    label: 'People',
    content: [
        {
            icon: 'fas fa-users',
            label: 'Users',
            to: `/dashboard/users`,
        },
        {
            icon: 'fas fa-users',
            label: 'Customers',
            to: `/dashboard/customers`,
            roles: ['SuperUser', 'Privileged'],
        },
    ],
}

let PartsANDOrdersMenu = {
    icon: 'fas fa-users',
    label: 'Parts And Orders',
    content: [],
}

ORDER_TYPE_CODE.forEach((x) => {
    PartsANDOrdersMenu.content.push({
        icon: 'fas fa-users',
        label: x.label,
        to: `/dashboard/gsx_orders/${x.code}`,
    })
})

export const SERVICE_MENU_ITEMS = [
    {
        icon: 'fas fa-home',
        label: 'Home',
        to: '/dashboard',
    },
    {
        icon: 'fas fa-building',
        label: 'Organizations',
        to: '/dashboard/organizations',
    },
    PeopleMenu,
    {
        icon: 'fas fa-tasks',
        label: 'Tickets',
        to: '/dashboard/tickets',
    },
    RepairMenu,
    {
        icon: 'fas fa-cogs',
        label: 'Inventory',
        content: [
            {
                icon: 'fas fa-cogs',
                label: 'Loaners Inventory',
                to: '/dashboard/loaners',
            },
            {
                icon: 'fas fa-wrench',
                label: 'Repairs Inventory',
                to: '/dashboard/repairs',
            },
            {
                icon: 'fas fa-hammer',
                label: 'Non Serializable Inventory',
                to: '/dashboard/non-serializable',
            },
            {
                icon: 'fas fa-hammer',
                label: 'Loaners Penalty',
                to: '/dashboard/loaners_penalty',
            },


        ],
    },
    {
        icon: 'fas fa-tools',
        label: 'In-stock ',
        content: [
            {
                icon: 'fas fa-tools',
                label: 'Repairs',
                to: '/dashboard/invertory_stats',
            },
            {
                icon: 'fas fa-tools',
                label: 'Loaner',
                to: '/dashboard/loaner_stats',
            },
        ],
    },
    {
        icon: 'fas fa-tasks',
        label: 'Tokens',
        to: '/dashboard/tokens',
        roles: ['SuperUser', 'Privileged'],
        managerAllowed: true
    },
    {
        icon: 'fas fa-sort-numeric-down',
        label: 'Reports',
        to: '/dashboard/reports',
    },
    {
        icon: 'fas fa-shield-alt',
        label: 'Support Packages',
        to: '/dashboard/support_packages',
    },
    {
        icon: 'fas fa-user',
        label: 'My Profile',
        to: '/dashboard/profile',
    },
    {
        icon: 'fas fa-tachometer-alt',
        label: 'Analytics',
        to: '/admin/analytics',
        roles: ['SuperUser', 'Privileged'],
    },
    {
        icon: 'fas fa-cog',
        label: 'Lists',
        to: '/dashboard/options',
    },
    {
        icon: 'fas fa-download',
        label: 'Billing',
        to: '/admin/billing',
        roles: ['SuperUser'],
    }
]
